import { render, staticRenderFns } from "./CyberAlarm.vue?vue&type=template&id=2e6c90ca&scoped=true&"
import script from "./CyberAlarm.vue?vue&type=script&lang=ts&"
export * from "./CyberAlarm.vue?vue&type=script&lang=ts&"
import style0 from "./CyberAlarm.vue?vue&type=style&index=0&id=2e6c90ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c90ca",
  null
  
)

export default component.exports